<!--  -->
<template>
  <div class="m_products">
    <mb-header></mb-header>

    <div class="header">
      <img src="../assets/logo.png" alt class="logo" />
    </div>
    <div class="select">
      <select
        name="public-choice"
        class="fast_search_select"
        v-model="selectTechValue"
      >
        <option value disabled>请选择齿轮类型</option>
        <option
          :value="item.id"
          v-for="item of productsTypeList"
          :key="item.id"
        >
          {{ item.product_type_name }}
        </option>
      </select>
      <div class="mask">
        <h3>{{ productsInfo ? productsInfo.copy_writing_title : "" }}</h3>
        <div
          class="mask_content"
          v-html="productsInfo && productsInfo.copy_writing_content"
        ></div>
      </div>
      <div class="list_img">
        <ul>
          <li v-for="(item, index) in productsList" :key="index">
            <a
              :href="item.product_name"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                :src="item.product_image_address"
                alt="img"
                class="list_li_img"
              />
              <!-- <div class="mask">
                  <div class="content">
                    <div class="name">{{ item.product_type_name }}</div>
                    <div class="link" @click="toDetail(item)">
                        去看看
                    </div>
                  </div>
                </div> -->
            </a>
            <!-- <p @click="Preview(item)">尺寸表</p> -->
            <a
              :href="item.product_big_image_address"
              target="_blank"
              rel="noopener noreferrer"
              class="btn"
              >尺寸表</a
            >
          </li>
        </ul>
      </div>
    </div>
    <div class="modal-bg" v-show="showImgDetailModal" @click="closeImgDetai">
      <div class="content" :class="{ active: showImgDetailModal }"></div>
    </div>
    <mb-fotter :class="{ active: islength }"></mb-fotter>
    <back-top></back-top>
  </div>
</template>

<script>
import mbHeader from "../components/moblie-header.vue";
import mbFotter from "../components/moblie-fotter.vue";
import backTop from "../components/back-top.vue";
import request from "../server/request.js";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    mbHeader,
    mbFotter,
    backTop,
  },

  data() {
    //这里存放数据
    return {
      selectTechValue: this.$route.params.id,
      curTabGuid: this.$route.params.id,
      productsTypeList: [],
      productsInfo: {
        copy_writing_title: "",
        copy_writing_content: "",
      },
      productsList: [],
      islength: false,
      showImgDetailModal: false,
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //监控data中的数据变化
  watch: {
    selectTechValue: function (val, oldval) {
      if (val !== oldval) {
        this.curTabGuid = val;
        this.loadData();
      }
    },
    productsList: function (val) {
      if (val.length <= 3) {
        if (
          Number(
            document.documentElement.clientHeight || document.body.clientHeight
          ) > 603
        ) {
          this.islength = true;
        } else {
          this.islength = false;
        }
      } else {
        this.islength = false;
      }
    },
  },

  //方法集合
  methods: {
    toDetail(e) {
      // this.$route.push('/detail')
      this.$router.push({ path: `/m_detail/${e.guid}` });
      // this.$router.push({ path: `/detail` })
    },
    showImgDetail(e) {
      console.log("1111111111111");
      console.log(e);
      this.showImgDetailModal = true;
    },

    closeImgDetai() {
      this.showImgDetailModal = false;
    },
    loadData() {
      request.getProductsType((res) => {
        if (res && res.errcode === 0) {
          this.productsTypeList = res.data;
        }
      });
      request.getProductsById(this.curTabGuid, (res) => {
        if (res && res.errcode === 0) {
          this.productsList = res.data;
        }
      });
      request.getProductsCenterInfo((res) => {
        if (res && res.errcode === 0) {
          if (res.data.length === 0) {
            this.productsInfo = {
              copy_writing_content: "",
              copy_writing_title: "",
            };
          } else {
            this.productsInfo = res.data.filter(
              (item) =>
                item.product_type_id == this.curTabGuid &&
                item.copy_writing_location === "Produces"
            )[0];
          }
        }
      });
    },
  },

  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loadData();
  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang='less' scoped>
.m_products {
  background: #fff;
  height: 100vh;
  .header {
    background: url("../assets/khk-003b.jpg") no-repeat;
    width: 100%;
    background-size: cover;
    vertical-align: top;
    height: 128px;
    .logo {
      margin: 0.3rem 0 0 0.3rem;
      width: 35%;
    }
  }
  .select {
    width: 90%;
    margin: 0.2rem auto;
    .fast_search_select {
      width: 100%;
      padding: 0.1rem 0;
      border-radius: 5px;
      border: 1px solid #ccc;
      text-align: center;
      height: auto;
      height: 0.64rem;
      color: #333;
    }
  }
  .mask {
    color: #333;
    h3 {
      font-size: 0.42rem;
      font-weight: 700;
      margin: 0.3rem 0;
    }
    .mask_content {
      color: #666;
    }
  }
  .list_img {
    width: 100%;
    position: relative;
    z-index: 10;
    display: flex;
    justify-content: center;
    ul {
      padding-top: 0.1rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      width: 620px;
      li {
        width: 32%;
        margin-right: 2%;
        // height: 198px;
        margin-bottom: 0.4rem;
        border-radius: 10px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        //   &:hover {
        //   width: 100%;
        //   height: 100%;
        //   background: rgba(0, 0, 0, 0.6);
        // }
        a {
          position: relative;
          display: block;
          width: 100%;

          // height: 178px;

          .mask {
            // display: visibility: hidden;;
            // visibility: hidden;
            display: none;
          }
          &:hover .mask {
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.45);
            .content {
              position: absolute;
              top: 50%;
              left: 50%;
              // margin: auto;
              transform: translate(-50%, -50%);
              font-weight: 500;
              color: #fff;
              font-size: 14px;
              text-align: center;
              .name {
                margin-bottom: 30px;
              }
              .link {
                width: 80px;
                height: 30px;
                background: #0583c9;
                line-height: 30px;
                border-radius: 5px;
                color: #fff;
              }
            }
          }
          .list_li_img {
            width: 100%;
            // height: 100%;
          }
        }

        .btn {
          text-align: center;
          cursor: pointer;
          width: 1.2rem;
          height: 0.44rem;
          border-radius: 3px;
          line-height: 0.44rem;
          margin: 0 auto;
          color: #0583c9;
          margin-top: 5px;
          border: 1px solid #0583c9;
          &:hover {
            color: #fff;
            background: #0583c9;
          }
        }
      }
    }
  }
  //   .modal-bg {
  //   background: rgba(0, 0, 0, 0.6);
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  //   width: 100%;
  //   height: 100%;
  //   z-index: 20;

  //   .content {
  //     width: 300px;
  //     height: 300px;
  //     position: absolute;
  //     top: 300px;
  //     left: 0;
  //     right: 0;
  //     margin: 0 auto;
  //     background: #8fcff1;
  //     transition: all 3s ease;
  //     z-index: 30;

  //   }

  // }
  .fotter.active {
    position: absolute;
  }
}
</style>